import { Col, Row, Tag } from 'antd';
import React from 'react';
var TotalGeofence = function (props) {
    return (React.createElement(Row, { style: {
            background: '#F2F5F8',
            height: 38,
            paddingInline: '16px',
            borderRadius: 8,
        }, align: 'middle', justify: 'space-between' },
        React.createElement(Col, null,
            React.createElement("h4", { style: {
                    fontSize: 12,
                    color: 'rgba(0,0,0,0.88)',
                    fontWeight: 600,
                } }, "Total Geofences")),
        React.createElement(Col, null,
            React.createElement(Tag, { style: { marginInline: 0 }, color: "blue" },
                props.total,
                " Total"))));
};
export default TotalGeofence;
